"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pollOption = exports.pollStatusBar = exports.optionImageContainer = exports.imageContainer = exports.imageIcon = exports.optionImage = exports.pollResultStyles = void 0;

var _emotion = require("emotion");

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var pollResultStyles =
/*#__PURE__*/
(0, _emotion.css)("display:flex;flex-direction:column;flex-grow:1;overflow:auto;.poll-question{font-family:'Playfair Display';overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;}.option + .option{margin-top:8px;}");
exports.pollResultStyles = pollResultStyles;
var optionImage =
/*#__PURE__*/
(0, _emotion.css)("height:100%;width:inherit;border-radius:3px;");
exports.optionImage = optionImage;
var imageIcon =
/*#__PURE__*/
(0, _emotion.css)("cursor:pointer;outline:none;");
exports.imageIcon = imageIcon;

var imageContainer = function imageContainer(heightWidth) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("border-radius:3px;width:", heightWidth, "px;height:", heightWidth, "px;margin-right:12px;")
  );
};

exports.imageContainer = imageContainer;

var optionImageContainer = function optionImageContainer(heightWidth) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("position:relative;border-radius:3px;width:", heightWidth, "px;height:", heightWidth, "px;.imageOverlay{display:none;}&:hover .imageOverlay{height:100%;width:100%;display:flex;position:absolute;top:0;left:0;bottom:0;right:0;opacity:0.9;border-radius:2px;background-color:rgba(0,0,0,0.85);align-items:center;justify-content:center;transition:all 0.5s ease-in-out;}.imageOptions{width:100%;display:flex;align-items:center;justify-content:space-around;}.imageOverlayOption{cursor:pointer;outline:none;}")
  );
};

exports.optionImageContainer = optionImageContainer;
var pollStatusBar =
/*#__PURE__*/
(0, _emotion.css)("margin:10px 0 36px;padding:0 10px;width:100%;height:26px;border-radius:1.4px;background-color:", _themeConfig.default.color.dark.mars, ";.seperator{margin:0 8px;}");
exports.pollStatusBar = pollStatusBar;

var pollOption = function pollOption(width, totalResponses, imageUrl) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("&.option{justify-content:space-between;border-radius:1.4px;.option-bar{position:relative;height:100%;border-radius:inherit;}.option-bar-wrapper{flex-grow:1;position:relative;background-color:", _themeConfig.default.color.dark.mars, ";height:32px;border-radius:inherit;", totalResponses > 0 && imageUrl &&
    /*#__PURE__*/
    (0, _emotion.css)("height:56px;"), "\n\n      ", totalResponses === 0 && imageUrl &&
    /*#__PURE__*/
    (0, _emotion.css)("height:104px;border-bottom:1px solid ", _themeConfig.default.color.dark.mars, ";"), "\n\n      .progress{height:100%;width:", width, "%;background-color:", _themeConfig.default.color.dark.mercury, ";border-radius:inherit;transition:all 250ms ease 0s;}.option-text{position:absolute;font-family:ChronicaPro-Medium;line-height:1.5;top:50%;left:10px;transform:translateY(-50%);display:flex;align-items:center;justify-content:center;.text{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;}}}.option-responses{font-family:ChronicaPro-Medium;margin-left:12px;margin-right:10px;flex-shrink:0;min-width:45px;text-align:right;}&.maximum{.option-bar-wrapper{.progress{background-color:", _themeConfig.default.color.dark.emerald, ";}}}&.multipleMaximum{.option-bar-wrapper{.progress{background-color:", _themeConfig.default.color.dark.mercury, ";}}}}")
  );
};

exports.pollOption = pollOption;